export default __webpack_public_path__ + "static/media/4.c36f5f05.webp";